/** @format */

import styled from "styled-components";
import TransactionRecieptModal from "./transactionrecieptmodal";
import { useState } from "react";

const Card = styled.div`
  width: 100%;
  padding: 0.62em 1.06em;
  margin: 0.6em auto;
  display: flex;
  cursor: pointer;
  border-radius: 0.5rem;
  border: 1px solid #f4f4f4;
  align-items: center;
  font-size: 0.875rem;
  justify-content: space-between;

  h3 {
    color: #000;
    font-weight: 700;
  }
  div {
    font-weight: 500;
    text-align: right;
    font-family: Poppins;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;

const Transactions = ({ transactions, setisConfirmed, isConfirmed }: any) => {
  const [isOpened, setIsOpened] = useState(false);
  const [details, setDetails] = useState();

  const toggleModal = () => {
    setIsOpened(!isOpened);
  };
  return (
    <>
      {" "}
      {isOpened && (
        <TransactionRecieptModal
          details={details}
          toggleModal={toggleModal}
          setisConfirmed={setisConfirmed}
          isConfirmed={isConfirmed}
        />
      )}
      {transactions?.map((transaction: any) => (
        <Card
          className=""
          key={transaction.uuid}
          onClick={() => {
            setIsOpened(!isOpened);

            setDetails(transaction);
          }}
        >
          <h3>{transaction.number}</h3>

          <div
            className={
              transaction.status === "PENDING"
                ? "text-[#C103C6]  "
                : " text-[#8B8B8B] "
            }
          >
            {transaction.status === "SUCCESSFUL"
              ? "Confirmed"
              : transaction.status === "PENDING"
              ? "Pending"
              : "Failed"}
          </div>
        </Card>
      ))}
    </>
  );
};

export default Transactions;
